<template>
  <div class="newSmanage">
    <el-tabs class="tab" v-model="activeName" @tab-click="tabClick">
      <el-tab-pane label="文章" name="ManageNews"></el-tab-pane>
      <el-tab-pane label="公告" name="NoticeS"></el-tab-pane>
    </el-tabs>
    <div class="head-content">
      <el-button type="primary" @click="addNotice">新增公告</el-button>
    </div>
    <el-divider content-position="left">PC公告</el-divider>
    <el-table :data="newsListPc" style="width: 100%">
      <el-table-column prop="id" label="id" width="100"> </el-table-column>
      <el-table-column prop="article_title" label="标题"> </el-table-column>
      <el-table-column
        prop="article_author"
        label="作者"
        width="200"
      ></el-table-column>
      <el-table-column
        prop="article_summary"
        label="简介"
        :show-overflow-tooltip="true"
      ></el-table-column>
      <el-table-column
        prop="article_content"
        label="公告内容"
        :show-overflow-tooltip="true"
      ></el-table-column>
      <el-table-column
        prop="article_type"
        label="公告类型"
        width="100"
        :formatter="article_type_atFormatter"
      ></el-table-column>
      <el-table-column
        prop="article_active"
        label="是否发布"
        width="100"
        :formatter="article_active_atFormatter"
      ></el-table-column>
      <el-table-column
        prop="created_at"
        label="创建日期"
        :formatter="created_atFormatter"
        width="200"
      ></el-table-column>
      <el-table-column fixed="right" label="操作" width="100">
        <template slot-scope="scope">
          <el-button
            type="text"
            size="small"
            @click="editNotice(scope.row)"
            v-if="scope.row.article_active ? false : true"
            >编辑</el-button
          >
        </template>
      </el-table-column>
    </el-table>
    <el-divider content-position="left">IOS公告</el-divider>
    <el-table :data="newsListIos" style="width: 100%">
      <el-table-column prop="id" label="id" width="100"> </el-table-column>
      <el-table-column prop="article_title" label="标题"> </el-table-column>
      <el-table-column
        prop="article_author"
        label="作者"
        width="200"
      ></el-table-column>
      <el-table-column
        prop="article_summary"
        label="简介"
        :show-overflow-tooltip="true"
      ></el-table-column>
      <el-table-column
        prop="article_content"
        label="公告内容"
        :show-overflow-tooltip="true"
      ></el-table-column>
      <el-table-column
        prop="article_type"
        label="公告类型"
        width="100"
        :formatter="article_type_atFormatter"
      ></el-table-column>
      <el-table-column
        prop="article_active"
        label="是否发布"
        width="100"
        :formatter="article_active_atFormatter"
      ></el-table-column>
      <el-table-column
        prop="created_at"
        label="创建日期"
        :formatter="created_atFormatter"
        width="200"
      ></el-table-column>
      <el-table-column fixed="right" label="操作" width="100">
        <template slot-scope="scope">
          <el-button
            type="text"
            size="small"
            @click="editNotice(scope.row)"
            v-if="scope.row.article_active ? false : true"
            >编辑</el-button
          >
        </template>
      </el-table-column>
    </el-table>

    <el-divider content-position="left">安卓公告</el-divider>
    <el-table :data="newsListAndroid" style="width: 100%">
      <el-table-column prop="id" label="id" width="100"> </el-table-column>
      <el-table-column prop="article_title" label="标题"> </el-table-column>
      <el-table-column
        prop="article_author"
        label="作者"
        width="200"
      ></el-table-column>
      <el-table-column
        prop="article_summary"
        label="简介"
        :show-overflow-tooltip="true"
      ></el-table-column>
      <el-table-column
        prop="article_content"
        label="公告内容"
        :show-overflow-tooltip="true"
      ></el-table-column>
      <el-table-column
        prop="article_type"
        label="公告类型"
        width="100"
        :formatter="article_type_atFormatter"
      ></el-table-column>
      <el-table-column
        prop="article_active"
        label="是否发布"
        width="100"
        :formatter="article_active_atFormatter"
      ></el-table-column>
      <el-table-column
        prop="created_at"
        label="创建日期"
        :formatter="created_atFormatter"
        width="200"
      ></el-table-column>
      <el-table-column fixed="right" label="操作" width="100">
        <template slot-scope="scope">
          <el-button
            type="text"
            size="small"
            @click="editNotice(scope.row)"
            v-if="scope.row.article_active ? false : true"
            >编辑</el-button
          >
        </template>
      </el-table-column>
    </el-table>
    <el-dialog
      :title="dialogTitle == 'add' ? '新增公告' : '编辑公告'"
      :visible.sync="dialogVisible"
      width="50%"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :destroy-on-close="true"
    >
      <div>
        <el-form
          :model="ruleForm"
          :rules="rules"
          ref="ruleForm"
          label-width="100px"
          class="demo-ruleForm"
        >
          <el-form-item label="标题" prop="article_title">
            <el-input v-model="ruleForm.article_title"></el-input>
          </el-form-item>
          <el-form-item label="简介" prop="article_summary">
            <el-input v-model="ruleForm.article_summary"></el-input>
          </el-form-item>
          <el-form-item label="作者" prop="article_author">
            <el-input v-model="ruleForm.article_author"></el-input>
          </el-form-item>
          <el-form-item label="类型" prop="article_type_copy">
            <el-select
              v-model="ruleForm.article_type_copy"
              placeholder="请选择公告类型"
              :disabled="disabled"
            >
              <el-option label="PC" value="3000"></el-option>
              <el-option label="Android" value="2000"></el-option>
              <el-option label="Ios" value="1000"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="内容" prop="article_content">
            <el-col>
              <el-input v-model="ruleForm.article_content"></el-input>
            </el-col>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="submitForm('ruleForm')"
              >提交</el-button
            >
          </el-form-item>
        </el-form>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  data () {
    return {
      total: 0,
      currentPage: 1,
      newsListPc: [],
      newsListIos: [],
      newsListAndroid: [],
      loading: false,
      dialogVisible: false,
      articleObj: {},
      activeName: 'NoticeS',
      dialogTitle: 'add',
      disabled: false,
      ruleForm: {
        article_title: '',
        article_summary: 'pc端公告',
        article_author: '海星云团队',
        article_type_copy: '',
        article_content: ''
      },
      rules: {
        article_title: [
          { required: true, message: '请输入标题', trigger: 'blur' }
        ],
        article_summary: [
          { required: true, message: '请输入简介', trigger: 'blur' }
        ],
        article_author: [
          { required: true, message: '请输入作者 例如：海星云团队', trigger: 'blur' }
        ],
        article_type_copy: [
          { required: true, message: '请选择公告类型', trigger: 'blur' }
        ],
        article_content: [
          { required: true, message: '请输入公告内容', trigger: 'blur' }
        ]
      }
    }
  },
  methods: {
    article_active_atFormatter (row) {
      return row.article_active ? '是' : '否'
    },
    article_type_atFormatter (row) {
      switch (row.article_type) {
        case 3000 : return 'PC'
        case 2000 : return 'Android'
        case 1000 : return 'Ios'
        default: return row.article_type || ''
      }
    },
    created_atFormatter (row) {
      return row.created_at.split('T').join(' ').split('+').shift()
    },
    handleClick (row) {
      setTimeout(() => {
        document.getElementsByClassName('el-dialog__wrapper')[0].scrollTop = 0
      }, 0)
      this.dialogVisible = true
      this.articleObj = row
      console.log(row)
    },
    tabClick (tab, event) {
      switch (tab.name) {
        case 'ManageNews':
          this.$router.push({
            path: './ManageNews'
          })
          break
        case 'NoticeS' :
          console.log('公告')
          break
        default: console.log('123')
      }
    },
    submitForm (formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let dataObj = this.ruleForm
          dataObj.article_type = Number(this.ruleForm.article_type_copy)
          if (this.dialogTitle === 'add') {
            console.log('新增公告', dataObj)
            this.http.addNews(dataObj).then((res) => {
              this.dialogVisible = false
              alert('新增成功!')
              this.getNewSList(this.currentPage)
            })
          }
          if (this.dialogTitle === 'edit') {
            console.log('编辑公告', dataObj)
            this.http.upNews(dataObj).then((res) => {
              this.dialogVisible = false
              alert('修改成功!')
              this.getNewSList(this.currentPage)
            }).catch(error => {
              this.$message({
                message: error.response.data.message2,
                type: 'warning'
              })
            })
          }
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },

    resetForm (formName) {
      this.$refs[formName].resetFields()
    },
    // 新增公告
    addNotice (row) {
      this.dialogTitle = 'add'
      this.dialogVisible = true
      this.disabled = false
      this.ruleForm = {
        article_title: '',
        article_summary: '',
        article_author: '海星云团队',
        article_type_copy: '',
        article_content: ''
      }
    },
    // 编辑公告
    editNotice (row) {
      this.dialogTitle = 'edit'
      this.disabled = true
      this.ruleForm = row
      this.ruleForm.article_type_copy = String(row.article_type)
      this.dialogVisible = true
    },
    currentChangeHandle (val) {
      this.currentPage = val
      console.log(val)
      sessionStorage.setItem('currentPage', val)
      this.getNewSList(val)
    },
    getNewSList (page) {
      this.loading = true
      this.http.queryManageNews({type: '3000', page: page}).then(res => {
        this.loading = false
        this.total = res.data.data.total_page * 10
        this.newsListPc = res.data.data.article_list
        this.$scrollTo()
      })
      this.http.queryManageNews({type: '1000', page: page}).then(res => {
        this.loading = false
        this.total = res.data.data.total_page * 10
        this.newsListIos = res.data.data.article_list
        this.$scrollTo()
      })
      this.http.queryManageNews({type: '2000', page: page}).then(res => {
        this.loading = false
        this.total = res.data.data.total_page * 10
        this.newsListAndroid = res.data.data.article_list
        this.$scrollTo()
      })
    }
  },

  mounted () {
    this.currentPage = 1
    this.getNewSList(this.currentPage)
  },
  destroyed () {
    this.loading = false
  }
}
</script>

<style lang="scss" scoped>
.newSmanage {
  .tab {
    margin: 10px 20px 0px;
  }
  .head-content {
    padding: 20px;
  }
  .page {
    text-align: center;
    margin: 30px 0;
  }
  .article_content {
    padding: 10px 15px;
    background: #0d0b26;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/manage/noticePage/index.vue